/*
 * @Author: your name
 * @Date: 2022-02-22 15:11:47
 * @LastEditTime: 2022-03-08 10:42:58
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /demander-manage/src/utils/request.js
 */
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'

// var loading = null
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
// console.log(axios.defaults.headers.post['Content-Type'])
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
//   console.log(config)
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  const token = getToken()
  //   console.log(token)
  if (getToken() && !isToken) {
    config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?'
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName]
      var part = encodeURIComponent(propName) + '='
      if (value !== null && typeof (value) !== 'undefined') {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            const params = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params) + '='
            url += subPart + encodeURIComponent(value[key]) + '&'
          }
        } else {
          url += part + encodeURIComponent(value) + '&'
        }
      }
    }
    url = url.slice(0, -1)
    config.params = {}
    config.url = url
  }
  // if (config.method === 'post') {
  //   config.params = {}
  // }
  // loading = Loading.service({
  //   lock: true,
  //   text: 'Loading',
  //   spinner: 'el-icon-loading',
  //   background: 'rgba(0,0,0,0.7)'
  // })
  return config
}, error => {
  Promise.reject(error)
})

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // console.log('---', res)
    // if the custom code is not 20000, it is judged as an error.
    if (res.code) {
      if (res.code !== 200 && res.code !== '200') {
        Message({
          message: res.message || res.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })

        // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
        if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
          // to re-login
          MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
            confirmButtonText: 'Re-Login',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            store.dispatch('user/resetToken').then(() => {
              location.reload()
            })
          })
        }
        return Promise.reject(new Error(res.message || res.msg || 'Error'))
      } else {
        return res
      }
    } else {
      if (response.config.url.indexOf('excel') === -1 && response.config.url.indexOf('export') === -1) {
        return res
      } else {
        return response
      }
    }
  },
  error => {
    // console.log('err' + error) // for debug
    // Message({
    //   message: error.msg,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    let newError = false
    if (error.response.data.message.indexOf('当前商品已下架')) {
      router.push({
        path: '/Home'
      })
      newError = true
    }
    const doms = document.getElementsByClassName('el-message')
    const outerTextArr = []
    for (const i in doms) {
      if (doms[i].outerText !== undefined) {
        outerTextArr.push(doms[i].outerText)
      }
    }
    let TableError = false
    let msg = error.message || error.msg || '服务失去连接'
    if (error.response.data.message.indexOf('登录验证失败') !== -1) {
      store.commit('user/SET_NAME', '')
      store.commit('user/SET_TOKEN', '')
      store.commit('user/SET_COMPANY', '')
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
      if (keys) {
        for (var i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
      }
      store.commit('user/CUSTOMER', '')
      sessionStorage.removeItem('vuex')
      sessionStorage.removeItem('company')
      // 清空vuex登录信息
      // this.setUser('')
      localStorage.removeItem('userInfo')
      router.push({
        path: '/login/login'
      })
      msg = '登录验证失败，请重新登录！'
    //   Message({
    //     message: '登录验证失败，请重新登录！',
    //     type: 'error',
    //     duration: 2 * 1000
    //   })
    //   return
    }
    if (newError) {
      msg = error.response.data.message
    }
    outerTextArr.forEach(item => {
      if (item === msg) {
        TableError = true
      }
    })
    if (!TableError) {
      Message({
        message: msg,
        type: 'error',
        duration: 2 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
